import {Controller} from "@hotwired/stimulus"

// A dropship address ships to someone other than the customer, so it is the only
// case that asks for a name. The field is disabled as well as hidden: a hidden but
// enabled field still posts, and an empty dropship_customer_name on a normal
// address is not the same thing as no field at all.
//
// Replaces the jQuery binding that lived in each new.js.erb, which only ran when
// that particular modal was opened over ajax.
export default class extends Controller {
    static targets = ["field", "name"]

    connect() {
        this.apply()
    }

    toggle() {
        this.apply()
    }

    apply() {
        const on = this.checkbox?.checked === true

        this.fieldTarget.classList.toggle("ice:hidden", !on)
        this.nameTarget.disabled = !on
        if (!on) this.nameTarget.value = ""
    }

    get checkbox() {
        return this.element.querySelector("#address_dropship")
    }
}
